<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em !important;">Graeme Lay was born in Foxton, in the Horowhenua district of New Zealand’s North Island. He grew up in the coastal province of Taranaki, which imbued him with a lifelong love of the sea. He attended Victoria University of Wellington, graduating in 1967. After living in England for several years, he returned to New Zealand, living on the North Shore of Auckland city. He began writing in the 1970s, firstly short stories, then novels.</p><br/>
<p style="text-indent:0em !important;">Many of his books draw their inspiration from the islands of the South Pacific, through which he has travelled extensively. He is now the author of over forty books: novels for adults and young adults, and collections of short stories and travel writing. His best-known work is a novel trilogy based on the life of English explorer James Cook. These are: <em>The Secret Life of James Cook</em>, <em>James Cook’s New World</em> and <em>James Cook’s Lost World</em> (Fourth Estate / Sharpe Books).</p><br/>
<p style="text-indent:0em !important;">Graeme Lay writes from his home in the maritime suburb of Devonport, on Auckland’s North Shore. He and his wife, Gillian, have three adult children.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?4c54ddc6